import HeroSection from "./components/HeroSection";
import MissionPreview from "./components/MissionPreview";
import ProjectsPreview from "./components/ProjectsPreview";
import StoriesPreview from "./components/StoriesPreview";
import ImpactSection from "./components/ImpactSection";
import PhotoSlider from "./components/PhotoSlider";
import VolunteerPreview from "./components/VolunteerPreview";
import DonatePreview from "./components/DonatePreview";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <MissionPreview />
      <ProjectsPreview />
      <StoriesPreview />
      <ImpactSection />
      <PhotoSlider />
      <VolunteerPreview />
      <DonatePreview />
    </main>
  );
}